<div class="growth-menu-main container">
  <div class="radio" >
    <label><input type="radio" name="optradio" [checked]="valueScheme==='Regular Plan - Growth Option'" value="Regular Plan - Growth Option" (change)="passBack($event)">
    <span>Regular Scheme</span> </label>   
  </div>
  <div class="radio" >
    <label><input type="radio" name="optradio" [checked]="valueScheme==='Direct Plan - Growth Option'" value="Direct Plan - Growth Option" (change)="passBack($event)">
      <span>Direct Scheme</span> </label>   
  </div>
</div>


